import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { QuinyxSetupRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { Box, Grid2 } from '@mui/material';
import { InputText } from '@/components/shared/InputText';
import {
    SecondaryButtonStyle,
    PrimaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';

interface QuinyxConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const QuinyxConnect = (props: QuinyxConnectProps) => {
    const { t } = useTranslation();
    const [credentials, setCredentials] = useState<QuinyxSetupRequest>({
        apiKey: ''
    });
    const { setAlert } = useNotificationsSnackbar();

    const { quinyxSetup } = usePaymentsMutations();

    const dispatch = useAppDispatch();

    const onClick = () => {
        quinyxSetup.mutate(credentials);
    };

    useEffect(() => {
        if (quinyxSetup.isSuccess) {
            props.onSaveSuccess?.();
        }
    }, [quinyxSetup.isSuccess]);

    useEffect(() => {
        dispatch(setLoader(quinyxSetup.isPending));
    }, [quinyxSetup.isPending]);

    useEffect(() => {
        if (quinyxSetup.isError) {
            setAlert('Connection failed', 'error');
        }
    }, [quinyxSetup.isError]);

    const isFormValid = () => {
        return credentials.apiKey?.trim().length > 0;
    };

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={credentials.apiKey}
                    label={t('api_key')}
                    placeholder={t('enter_api_key')}
                    onChange={(e) => {
                        setCredentials({
                            ...credentials,
                            apiKey: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid2
                container
                spacing={2}
                justifyContent={'space-around'}
                sx={{ m: '20px 0' }}
            >
                <Grid2>
                    <SecondaryButtonStyle
                        onClick={props?.onClose}
                        sx={{ width: '170px' }}
                    >
                        {t('cancel')}
                    </SecondaryButtonStyle>
                </Grid2>

                <Grid2>
                    <PrimaryButtonStyle
                        onClick={onClick}
                        sx={{ width: '170px' }}
                        disabled={!isFormValid()}
                        loading={quinyxSetup.isPending}
                    >
                        {t('connect')}
                    </PrimaryButtonStyle>
                </Grid2>
            </Grid2>
        </>
    );
};
